export default {"src":"/_next/static/media/starB.4fee6bb0.svg","height":47,"width":48,"blurWidth":0,"blurHeight":0};